<template>
  <div class="wrap">
    <el-card class="card">
      <div slot="header">登录（管理员）</div>
      <div style="height: 12px;"></div>

      <el-form label-width="90px">
        <el-form-item label="账号">
          <el-input v-model.trim="form.username" autocomplete="username" />
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="form.password" type="password" autocomplete="current-password" show-password />
        </el-form-item>
      </el-form>

      <div style="height: 12px;"></div>

      <el-button type="primary" style="width: 100%;" :loading="loading" @click="onLogin">
        进入后台
      </el-button>
    </el-card>
  </div>
</template>

<script>
import { setToken } from "@/utils/token";
import { adminLogin, getMe } from "@/api";

export default {
  name: "Login",
  data() {
    return {
      form: {
        username: "",
        password: ""
      },
      loading: false
    };
  },
  methods: {
    async onLogin() {
      this.loading = true;
      try {
        const res = await adminLogin(this.form);
        const token = res && res.data && res.data.token;
        if (!token) throw new Error("missing_token");
        setToken(token);
        await getMe(); // 验证 token 有效
        this.$router.replace("/");
      } catch (e) {
        setToken("");
        this.$message.error("账号或密码错误，或后端不可达");
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.wrap {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.card {
  width: 520px;
}
</style>

